var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-contents"},[(_vm.dialogId && _vm.context)?_c('portal',{attrs:{"to":`${_vm.dialogId}.${_vm.$dialogs.slots.content}`}},[_c('signature-account-setup',{attrs:{"context":_vm.context,"preview-context":_vm.signaturePreview,"dialog-id":_vm.dialogId,"is-active":_vm.isActive}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }